import React from 'react'
import styled from '@emotion/styled'
import { colors } from 'style/theme'
import Moment from 'react-moment'
import { Button } from 'antd'
import  downloadInvoice  from './DownloadInvoice'

const StyledCol = styled.span({
  fontWeight: 700,
  fontSize: '0.9rem'
})

const StyledDate = styled(StyledCol)({
  color: colors.brandTextLight
})

function TransactionsColumns(fetchTransactionDetails) {
  
  return [
    {
      title: 'TRANSACTION AMOUNT',
      dataIndex: 'amount',
      align: 'left',
      width: '30%',
      render(amount) {
        return <StyledCol>${amount}</StyledCol>
      }
    },
    {
      title: 'CREDITS',
      dataIndex: 'credits',
      align: 'center',
      render(credits) {
        return <StyledCol>{credits}</StyledCol>
      }
    },
    // {
    //   title: 'CREDIT CARD',
    //   dataIndex: 'last4_digits',
    //   render(last4) {
    //     return (
    //       <StyledCol>{last4}</StyledCol>
    //     )
    //   }
    // },
    {
      title: 'TRANSACTION DATE',
      dataIndex: 'date',
      render(date) {
        return (
          <StyledDate>
            {console.log(date)}
            <Moment date={new Date(date)} format="MM-DD-YYYY" />
            </StyledDate>
        )
      }
    },
    {
      title: 'INVOICE',
      dataIndex: 'invoice_id',
      render(invoice_id) {
        return (
          invoice_id ?
          <Button onClick={() => downloadInvoice(invoice_id)} type="link" icon="download">Download Invoice</Button> 
          :
          <StyledCol>Invoice not available yet</StyledCol>
        )
      }
    },
    {
      key: 'view usage',
      dataIndex: 'date',
      width: 100,
      render(date) {
        return (
          <Button onClick={() => fetchTransactionDetails(date)} type="link" icon="eye">VIEW USAGE</Button> 
        )
      }
    }
  ]
}

export default TransactionsColumns
